<div
  class="profile-filter"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = !isOpen"
>
  <input type="text" [placeholder]="selectedFilterText" readonly />
  <span matSuffix class="material-icons arrow-icons" *ngIf="!isOpen">
    expand_more
  </span>

  <span matSuffix class="material-icons arrow-icons" *ngIf="isOpen">
    expand_less
  </span>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    (overlayOutsideClick)="isOpen = false"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayHasBackdrop]="true"
    (detach)="isOpen = false"
    (backdropClick)="isOpen = false"
  >
    <app-select-simple-list
      [hideSearchComponent]="true"
      [hidePhoto]="true"
      [selectAllText]="profilesSelectAllText"
      [list]="profilesList"
      (selectEvent)="handleProfileSelect($event)"
      class="custom-overlay"
    >
    </app-select-simple-list>
  </ng-template>
</div>
